<template>
    <div>
      <Header />
  
      <main class="app-content">
        <div class="app-title">
          <div>
            <h1
              style="
      display: flex;
      justify-content: center;
      align-items: center;
      background: #19c6f1;
      text-align: center;
      border-radius: 7px 7px;
  "
            >
              
              BİTEN SAHALAR
            </h1>
          </div>
          <ul class="app-breadcrumb breadcrumb">
            <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
            <li class="breadcrumb-item"><a href="#">SAHALAR</a></li>
          </ul>
        </div>
        <div class="row">
          <div
            class="col-lg-12 col-md-12 rowHomepage"
            style="display: -webkit-box"
          >
            <div
              v-for="(item, index) in sahalar"
              :key="index"
              class="col-md-3 col-lg-3"
              style="margin-bottom: 22px; height:110px"
              v-if="sahalar[index].isyuzdesi >= 100 "
            >
              <div
                style="
              display: flex;
              justify-content: center;
              align-items: center;
              background-color: rgba(122, 154, 161, 0.61);"
                class="tileHomepage"
              >
                <div class="about-content">
                  <div>
                    <p
                      v-if="
                        sahalar[index].isyuzdesi <= 25 &&
                          sahalar[index].isyuzdesi >= 0
                      "
                      @click="routePage(item)"
                      id="kirmizi"
                    >
                      {{ sahalar[index].sahaName }} -
                      {{ sahalar[index].isyuzdesi }}%
                    </p>
                    <p
                      v-if="
                        sahalar[index].isyuzdesi <= 55 &&
                          sahalar[index].isyuzdesi >= 26
                      "
                      @click="routePage(item)"
                      id="turuncu"
                    >
                      {{ sahalar[index].sahaName }} -
                      {{ sahalar[index].isyuzdesi }}%
                    </p>
                    <p
                      v-if="
                        sahalar[index].isyuzdesi <= 75 &&
                          sahalar[index].isyuzdesi >= 56
                      "
                      @click="routePage(item)"
                      id="sari"
                    >
                      {{ sahalar[index].sahaName }} -
                      {{ sahalar[index].isyuzdesi }}%
                    </p>
                    <p
                      v-if="
                        sahalar[index].isyuzdesi <= 99 &&
                          sahalar[index].isyuzdesi >= 76
                      "
                      @click="routePage(item)"
                      id="yesil"
                    >
                      {{ sahalar[index].sahaName }} -
                      {{ sahalar[index].isyuzdesi }}%
                    </p>
                    <p
                      v-if="
                        sahalar[index].isyuzdesi <= 150 &&
                          sahalar[index].isyuzdesi >= 100
                      "
                      @click="routePage(item)"
                      id="mavi"
                    >
                      {{ sahalar[index].sahaName }} -
                      {{ sahalar[index].isyuzdesi }}%
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
  
      <Sidebar />
    </div>
  </template>
  
  <script>
  import Header from "./default/Header";
  import Sidebar from "./default/Sidebar";
  import axios from "axios";
  import store from "../store";
  export default {
    data() {
      return {
        sahalar: [],
      };
    },
    methods: {
      routePage: function(item) {
        window.location.href = "#/yeodetail?id=" + item.id+ item.keycode;
      },
    },
    mounted() {
      window.scrollTo(0, 0);
      var id = localStorage.getItem("id");
  
      var datas = {
      id: id,
    };
    var url = store.state.base_url + "AslanSahalar/yeoGetAllSaha.php?key=123";
    axios
    .post(url, JSON.stringify(datas)).then((response) => {
        this.sahalar = response.data;
          // console.log(response.data[0].sahaName);
        })
        .catch((err) => {
          console.log(err.response);
        });
  
      setTimeout(function() {
        //alert("Sayfa yenilendi");
        window.location.reload(1);
      }, 250000);
    },
    components: {
      Header,
      Sidebar,
    },
  };
  </script>
  
  <style>
  #kirmizi {
    border-radius: 15px 50px;
    background-color: #ef1c1c;
    text-align: center;
    font-size: 25px;
  }
  #turuncu {
    border-radius: 15px 50px;
    background-color: #ff9900;
    text-align: center;
    font-size: 25px;
  }
  #sari {
    border-radius: 15px 50px;
    background-color: #f4ff2d;
    text-align: center;
    font-size: 25px;
  }
  #yesil {
    border-radius: 15px 50px;
    background-color: #76f118;
    text-align: center;
    font-size: 25px;
  }
  #mavi {
    border-radius: 15px 50px;
    background-color: #19c6f1;
    text-align: center;
    font-size: 25px;
  }
  #pid1:hover {
    border-radius: 15px 50px;
    background-color: #63ca92;
    text-align: center;
    font-size: 25px;
  }
  #pid2:hover {
    border-radius: 15px 50px;
    background-color: #63ca92;
    text-align: center;
    font-size: 25px;
  }
  #pid3:hover {
    border-radius: 15px 50px;
    background-color: #63ca92;
    text-align: center;
    font-size: 25px;
  }
  #pid4:hover {
    border-radius: 15px 50px;
    background-color: #63ca92;
    text-align: center;
    font-size: 25px;
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/components/YeoComplateSaha.vue